module.exports = __webpack_public_path__ + "static/media/1.a7758fb3.png";